import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Column } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { getSpacing } from "@faire/web/slate/spacing";
import React, { Suspense } from "react";
import styled from "styled-components";
export var LazyDsaForm = function LazyDsaForm() {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingSpinnerContainer, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
      size: "large"
    }))
  }, /*#__PURE__*/React.createElement(LazyDsaFormBase, null));
};
var LazyDsaFormBase = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "dsa-form" */"./DsaForm").then(function (module) {
    return {
      "default": module.DsaForm
    };
  });
});
var LoadingSpinnerContainer = styled(Column).attrs({
  align: "center",
  justify: "center"
}).withConfig({
  displayName: "LazyDsaForm__LoadingSpinnerContainer"
})(["padding:", ";width:width:min(100%,690px);"], getSpacing("8x"));